module.exports = __webpack_public_path__ + "img/conversations.png";